import React, { useEffect } from "react";
import { Flex, Box } from "rebass";
import { theme } from "../../utils/theme";
import { ModalLayout } from "../../layouts/ModalLayout";
import { userActions } from "../../logic/actions";
import { Label, Input } from "@rebass/forms";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { MainButton } from "../../components";

const EditUserPage = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();

  const { register, handleSubmit, errors } = useForm();

  const onSubmit = (data) => {
    dispatch(userActions.login(data.email, data.password));
  };

  useEffect(() => {}, []);

  return (
    <ModalLayout show={isOpen} onClose={closeModal}>
      <Box width={1 / 2} as="form" onSubmit={handleSubmit(onSubmit)} py={3}>
        <Box
          width={1}
          fontSize={theme.textBig}
          fontWeight={800}
          color={theme.black}
          mb={4}
        >
          Sign In to Habit
        </Box>

        <Box style={{ marginBottom: 20 }}>
          <Label py={1} htmlFor="email">
            Username or Email Address
          </Label>
          <Input
            id="email"
            name="email"
            type="email"
            ref={register({ required: true })}
            placeholder="john.doe@domain.com"
          />
          {errors.email && <span>This field is required</span>}
        </Box>

        <Box style={{ marginBottom: 40 }}>
          <Flex justifyContent="space-between" py={1} w={1}>
            <Label htmlFor="password">Password</Label>
            <Label justifyContent="flex-end" htmlFor="password">
              Forgot Password?
            </Label>
          </Flex>
          <Input
            id="password"
            name="password"
            type="password"
            ref={register({ required: true })}
            placeholder="your password"
          />
          {errors.password && <span>This field is required</span>}
        </Box>

        <MainButton type="primary" label="Sign In" sx={{ width: "50%" }} />
      </Box>
    </ModalLayout>
  );
};

export { EditUserPage };
